import { Injectable } from "@angular/core";
import { Adapter } from "./adapter"
import { Team } from "./team";
import { Role } from "./role";
import { Skill } from "./skill";
import { ITeamAllocation } from "../_interfaces/teamAllocation";

export class People {
    
    constructor(
        public id: number = 0,
        public firstName: string = '', 
        public lastName: string = '',
        public is_contractor: boolean = false,
        public hiring_date: string = '',
        public exit_date: string = '',
        public teams: ITeamAllocation[] = [],
        public createdAt: Date = new Date(), 
        public updatedAt: Date | null = null,
        public skills: Skill[] = [],
        public role: Role | null = null,
        public avatar: string = '',
        public avatar_url: string = '',
        public total_allocation_rate: number = 0
        ){}
}

@Injectable({
    providedIn: "root",
})

export class PeopleAdapter implements Adapter<People> {
  adapt(item: any): People {
    let skills: Skill[] = [];
    let teams: ITeamAllocation[] = []; 

    if (item.skills) {
      skills = item.skills.map((skill: any) => new Skill(
        skill.id,
        skill.name,
        skill.description,
        new Date(skill.created_at),
        new Date(skill.updated_at)
      ));
    }

    if (item.teams) {
      teams = item.teams.map((teamAllocation: any) => ({
        allocation_rate: teamAllocation.allocation_rate,
        startDate: teamAllocation.start_date,
        endDate: teamAllocation.end_date ? teamAllocation.end_date  : undefined,
        team: new Team(
          teamAllocation.team.id,
          teamAllocation.team.name,
          teamAllocation.team.description,
          new Date(teamAllocation.team.created_at),
          new Date(teamAllocation.team.updated_at),
          skills,
          teamAllocation.team.roles,
          teamAllocation.team.team_type
        )
      }));
    }

    const updatedAt = item.updated_at ? new Date(item.updated_at) : null;

    const adaptedPeople = new People(); 
    adaptedPeople.id = item.id;
    adaptedPeople.firstName = item.firstname;
    adaptedPeople.lastName = item.lastname;
    adaptedPeople.is_contractor = item.is_contractor;
    adaptedPeople.hiring_date = item.hiring_date;
    adaptedPeople.exit_date = item.exit_date;
    adaptedPeople.teams = teams;
    adaptedPeople.createdAt = new Date(item.created_at);
    adaptedPeople.updatedAt = updatedAt;
    adaptedPeople.skills = skills;
    adaptedPeople.role = item.role;
    adaptedPeople.avatar = item.avatar;
    adaptedPeople.avatar_url = item.avatar_url;
    adaptedPeople.total_allocation_rate = item.total_allocation_rate;

    return adaptedPeople;
  }

  adaptToApi(person: People): any {
    return {
      id: person.id,
      firstname: person.firstName,
      lastname: person.lastName,
      is_contractor: person.is_contractor,
      hiring_date: person.hiring_date,
      exit_date: person.exit_date || null,
      created_at: person.createdAt,
      updated_at: person.updatedAt,
      teams: person.teams.map(teamAllocation => ({
        allocation_rate: teamAllocation.allocation_rate,
        start_date: teamAllocation.startDate,
        end_date: teamAllocation.endDate,
        team: {
          id: teamAllocation.team.id,
          name: teamAllocation.team.name,
          description: teamAllocation.team.description,
          created_at: teamAllocation.team.createdAt,
          updated_at: teamAllocation.team.updatedAt
        }
      })),
      skills: person.skills.map(skill => ({
        id: skill.id,
        name: skill.name,
        description: skill.description,
        created_at: skill.createdAt,
        updated_at: skill.updatedAt
      })),
      role: person.role ? {
        id: person.role.id,
        name: person.role.name,
        description: person.role.description,
        created_at: person.role.createdAt,
        updated_at: person.role.updatedAt
      } : null
    };
  }

  convertTeamAllocationsToApiFormat(allocations: ITeamAllocation[]): any[] {
    return allocations.map(allocation => ({
      team: allocation.team.id,
      allocation_rate: allocation.allocation_rate
    }));
  }
}

